import DashBoardContainer from './DashBoardContainer';
import DashBoard from './DashBoard';
export const DashBoardIndex = {
  DashBoardContainer,
  DashBoard,
};
